export const SampleProgramPreview =
  'https://sellwith.communityimpact.ai/program-preview/6511c1e48d0e363290504e52?sio_funding_amt=50000';
